import React from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'

class WPEngineCancelled extends React.Component {
	render() {
		const { migrate } = this.props
		return <div className="wpe d-flex">
			<div className="migration-results">
				<img width="300" height="300" src="/assets/wpengine/migration-failure.svg" alt="migration-failure-logo"/>
				<h1 className="align-center">Migration cancelled</h1>
				<div className="migration-results-text">
					<p>Source: <a href={migrate.get('source_site')} target="_blank" rel="noopener noreferrer">{migrate.get('source_site')}</a></p>
					<p>Destination: <a href={migrate.get('destination_site')} target="_blank" rel="noopener noreferrer">{migrate.get('destination_site')}</a></p>
				</div>
				<button className="button cancel-button" onClick={() => this.routeTo('http://my.wpengine.com/')}>
					Go to my.wpengine.com
				</button>
			</div>
		</div>
	}
}

WPEngineCancelled.propTypes = {
	migrate: ImmutablePropTypes.map
}

export default WPEngineCancelled
